// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
var ref = allVue.ref;
var inject = allVue.inject;
import { guid, getTabIndex, getDefaultSlots, templateRendering, getTemplate, getListeners, kendoThemeMaps, setRef, getRef } from '@progress/kendo-vue-common';
import { validatePackage } from '@progress/kendo-vue-common';
import { packageMetadata } from '../package-metadata';
/**
 * @hidden
 */
var RadioButtonVue2 = {
  name: 'KendoRadioButton',
  props: {
    ariaDescribedBy: String,
    checked: Boolean,
    disabled: Boolean,
    className: String,
    content: [String, Number, Boolean, Object],
    dataItem: Object,
    id: String,
    label: String,
    labelRender: [String, Number, Boolean, Object],
    item: [String, Number, Boolean, Object],
    labelPlacement: String,
    name: String,
    index: Number,
    tag: {
      type: String,
      default: 'div'
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(value) {
        return [null, 'small', 'medium', 'large'].includes(value);
      }
    },
    tabIndex: Number,
    value: [String, Number, Object],
    valid: {
      type: Boolean,
      default: undefined
    }
  },
  // @ts-ignore
  emits: {
    change: null,
    focus: null,
    blur: null
  },
  created: function created() {
    this.calculatedId = guid();
    validatePackage(packageMetadata);
  },
  mounted: function mounted() {
    this.input = getRef(this, 'input');
  },
  computed: {
    inputClassName: function inputClassName() {
      var _a;
      return _a = {
        'k-radio': true
      }, _a["k-radio-".concat(kendoThemeMaps.sizeMap[this.$props.size])] = this.$props.size, _a['k-invalid'] = this.$props.valid === false, _a[this.$props.className] = this.$props.className, _a;
    }
  },
  methods: {
    focusElement: function focusElement() {
      if (this.input) {
        this.input.focus();
      }
    },
    handleChange: function handleChange(event) {
      this.$emit('change', {
        event: event,
        value: this.$props.value
      });
    },
    handleFocus: function handleFocus(event) {
      if (!this.$props.disabled) {
        this.$emit('focus', event, undefined);
      }
    },
    handleBlur: function handleBlur(event) {
      if (!this.$props.disabled) {
        this.$emit('blur', event, undefined);
      }
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    var inputRef = ref(null);
    return {
      v3: v3,
      inputRef: inputRef
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    var _a = this.$props,
      ariaDescribedBy = _a.ariaDescribedBy,
      checked = _a.checked,
      disabled = _a.disabled,
      id = _a.id,
      label = _a.label,
      labelRender = _a.labelRender,
      labelPlacement = _a.labelPlacement,
      name = _a.name,
      tabIndex = _a.tabIndex,
      value = _a.value,
      tag = _a.tag;
    var renderedLabel = label;
    if (labelRender) {
      var renderTemplate = labelRender ? templateRendering.call(this, labelRender, getListeners.call(this)) : null;
      renderedLabel = getTemplate.call(this, {
        h: h,
        template: renderTemplate
      });
    }
    var content = getTemplate.call(this, {
      h: h,
      template: this.$props.content
    });
    var radioButtonLabel = renderedLabel !== undefined ? h("label", {
      "class": 'k-radio-label',
      "for": id || this.calculatedId,
      attrs: this.v3 ? undefined : {
        "for": id || this.calculatedId,
        "aria-label": label
      },
      style: {
        userSelect: 'none'
      },
      "aria-label": label
    }, [renderedLabel]) : null;
    var radio = h("input", {
      type: 'radio',
      attrs: this.v3 ? undefined : {
        type: 'radio',
        id: id || this.calculatedId,
        name: name,
        disabled: disabled,
        tabindex: getTabIndex(tabIndex, disabled),
        "aria-describedby": ariaDescribedBy
      },
      id: id || this.calculatedId,
      name: name,
      "class": this.inputClassName,
      ref: setRef(this, 'input'),
      disabled: disabled,
      tabindex: getTabIndex(tabIndex, disabled),
      checked: this.v3 ? checked : null,
      domProps: this.v3 ? undefined : {
        "checked": checked,
        "value": value
      },
      style: this.$attrs.style,
      "aria-describedby": ariaDescribedBy,
      value: this.v3 ? value : null,
      onChange: this.handleChange,
      on: this.v3 ? undefined : {
        "change": this.handleChange,
        "focus": this.handleFocus,
        "blur": this.handleBlur
      },
      onFocus: this.handleFocus,
      onBlur: this.handleBlur
    });
    var defaultRendering = labelPlacement === 'before' ? h(tag, [radioButtonLabel, radio, content, defaultSlot]) : h(tag, [radio, radioButtonLabel, content, defaultSlot]);
    return getTemplate.call(this, {
      h: h,
      template: this.$props.item,
      defaultRendering: defaultRendering,
      defaultSlots: defaultSlot,
      additionalListeners: {
        change: this.handleChange,
        focus: this.handleFocus,
        blur: this.handleBlur
      },
      additionalProps: {
        dataItem: this.$props.dataItem
      }
    });
  }
};
/**
 * @hidden
 */
var RadioButton = RadioButtonVue2;
export { RadioButton, RadioButtonVue2 };